import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface PutTagCategoryMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface PutTagCategoryParams {
	categoryId: string | null;
	tagId: string;
	impersonationContext?: Api.IImpersonationContext;
}

export function usePutTagCategoryMutation({ onSuccess, onError }: PutTagCategoryMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ categoryId, tagId, impersonationContext }: PutTagCategoryParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tag/${tagId}/categoryId`,
					queryParams: {
						value: categoryId,
					},
				}),
				'PUT'
			);
		},
		onSuccess,
		onError,
	});
}
